export default "__VITE_ASSET__DadvMUDc__"